import { render, staticRenderFns } from "./AdminSlider.vue?vue&type=template&id=b0356dea&scoped=true&"
import script from "./AdminSlider.vue?vue&type=script&lang=js&"
export * from "./AdminSlider.vue?vue&type=script&lang=js&"
import style0 from "./AdminSlider.vue?vue&type=style&index=0&id=b0356dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0356dea",
  null
  
)

export default component.exports